import { useDispatch, useSelector } from "react-redux";

export function useAppDispatch() {
  return useDispatch();
}

/**
 * @template T
 * @param {(state: import("./store").RootState) => T} selector
 */
export function useAppSelector(selector) {
  return useSelector(selector);
}
